'use strict';

var _ = require('lodash');
var ChartDashboardRankingsDataService = function ChartDashboardRankingsDataService($q, dashboardAggregatingService, dataRetrieverService, retrieverConstant) {
  var dataRetriever = dataRetrieverService.getDataRetriever(retrieverConstant.DASHBOARD_SCREEN, retrieverConstant.MARKET_DASHBOARD_MODE);
  var barSpaceWidth = 52;
  var aggregationMap = {
    LY: 'finalRef',
    SEASONAL_AVG: 'finalRef',
    BUDGET: 'budget',
    TARGET: 'target'
  };
  function getBarSpaceWidth() {
    return barSpaceWidth;
  }
  function getCircles(v2, v1) {
    var circles = [];
    if (v1 !== undefined) {
      circles.push({
        value: v1,
        css: 'm3-circle'
      });
    }
    if (v2 !== undefined) {
      circles.push({
        value: v2,
        css: 'm4-circle'
      });
    }
    return circles;
  }
  function getPercentage(v1, v2) {
    return v2 === 0 ? 0 : (v1 / v2 - 1) * 100;
  }
  function aggregateBarData(data, selectedMonths, screenState) {
    var result = dashboardAggregatingService.aggregateForMonths(data, screenState.selectedMetric.id, screenState.aggregationMode, selectedMonths);
    if (_.isEmpty(result)) {
      return false;
    }
    var refMode = screenState.aggregationMode !== 'BUDGET' && screenState.aggregationMode !== 'TARGET';
    result.referenceValue = result[aggregationMap[screenState.aggregationMode]];
    result.percentageChange = getPercentage(result.expected, result.referenceValue);
    if (screenState.dataRepresentation === 'percentage') {
      result.m1 = 0;
      result.m2 = result.percentageChange;
      result.tiles = [];
      result.circles = refMode ? getCircles(getPercentage(result.current, result.currentRef)) : [];
    } else {
      result.m1 = result.current;
      result.m2 = result.expected;
      result.tiles = result.current > result.expected ? [{
        m2: result.expected
      }] : [];
      result.circles = refMode ? getCircles(result.referenceValue, result.currentRef) : getCircles(result.referenceValue);
    }
    return result;
  }
  function filterDataByBrush(data, brush) {
    var rankingName = _.get(brush, 'rankingName');
    var rankingValues = _.get(brush, rankingName);
    return _.isEmpty(rankingValues) ? data : _.filter(data, function (item) {
      return _.includes(rankingValues, item[rankingName]);
    });
  }
  function groupByRanking(rankingName, rankings, data, screenState, brush) {
    var result = {
      overPerformingData: [],
      underPerformingData: []
    };
    if (_.isEmpty(rankings)) {
      return result;
    }
    var selectedMonths = _.get(dataRetriever.brushFilters(), 'year-and-month.filterArguments[0]', null);
    var filteredData = filterDataByBrush(data, brush);
    var grouped = {};
    for (var index = 0, dataLength = filteredData.length; index < dataLength; index++) {
      var element = filteredData[index];
      if (!grouped[element[rankingName]]) {
        grouped[element[rankingName]] = [element];
      } else {
        grouped[element[rankingName]].push(element);
      }
    }
    var groupedKeys = Object.keys(grouped);
    for (index = 0, dataLength = Object.keys(grouped).length; index < dataLength; index++) {
      var bar = grouped[groupedKeys[index]];
      var values = aggregateBarData(bar, selectedMonths, screenState);

      // no data
      if (!values) {
        continue;
      }
      var isOverPerforming = values.percentageChange > 0;
      var barData = _.assign({}, values, {
        isGap: false,
        label: groupedKeys[index],
        stackLabel: groupedKeys[index],
        tooltipDirection: isOverPerforming ? 'n' : 's'
      });
      if (isOverPerforming) {
        result.overPerformingData.push(barData);
      } else {
        result.underPerformingData.push(barData);
      }
    }
    result.overPerformingData = _.orderBy(result.overPerformingData, 'percentageChange', 'desc');
    result.underPerformingData = _.orderBy(result.underPerformingData, 'percentageChange', 'asc');
    var collectionForNoDataBars = _.isEmpty(result.overPerformingData) ? result.underPerformingData : result.overPerformingData;
    if (rankings && _.isArray(collectionForNoDataBars)) {
      var noDataBars = createNoDataBars(result, rankings);
      Array.prototype.push.apply(collectionForNoDataBars, noDataBars);
    }
    return result;
  }
  function getEntitiesList(data) {
    return _.chain(data).map('label').uniq().value();
  }
  function extractFilters(result) {
    return {
      market: {
        over: getEntitiesList(result.market.overPerformingData),
        under: getEntitiesList(result.market.underPerformingData)
      },
      pos: {
        over: getEntitiesList(result.pos.overPerformingData),
        under: getEntitiesList(result.pos.underPerformingData)
      }
    };
  }
  function aggregate(data, screenState, brushes) {
    var result = {};
    var allRankings = {
      market: _.chain(data).map('market').uniq().compact().value(),
      pos: _.chain(data).map('pos').uniq().compact().value()
    };
    result.market = groupByRanking('market', allRankings.market, data, screenState, _.assign(brushes, {
      rankingName: 'pos'
    }));
    result.pos = groupByRanking('pos', allRankings.pos, data, screenState, _.assign(brushes, {
      rankingName: 'market'
    }));
    result.filter = extractFilters(result);
    return result;
  }
  function createNoDataBars(result, rankings) {
    var noDataBars = [];
    for (var rankingIndex = 0, ranking_length = rankings.length; rankingIndex < ranking_length; rankingIndex++) {
      var ranking = rankings[rankingIndex];
      var overPerformingDataForRanking = _.filter(result.overPerformingData, {
        label: ranking
      });
      var underPerformingDataForRanking = _.filter(result.underPerformingData, {
        label: ranking
      });
      if (overPerformingDataForRanking.length === 0 && underPerformingDataForRanking.length === 0) {
        noDataBars.push({
          tiles: [],
          isGap: true,
          label: ranking
        });
      }
    }
    return noDataBars;
  }
  function getData(screenState, brushes) {
    return dataRetriever.localSortApplied().retrieveComponentData('dashboard-rankings', screenState.selectedMetric.id).then(function (data) {
      return aggregate(data, screenState, brushes);
    });
  }
  return {
    getData: getData,
    getBarSpaceWidth: getBarSpaceWidth
  };
};
ChartDashboardRankingsDataService.$inject = ['$q', 'DashboardAggregatingService', 'DataRetrieverService', 'DataRetrieverConstantsService'];
module.exports = ChartDashboardRankingsDataService;